module.exports = __webpack_public_path__ + "img/games-20.5c674fe4.webp";